/* eslint-disable @typescript-eslint/no-explicit-any */
import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import IntlPolyfill from 'intl';

import Languages from 'common/config/constants/languages';

import { pascalCase, removePrefix } from '../helpers/string';
import { getQueryParam } from '../helpers/url';

import 'intl/locale-data/jsonp/en';

const awsLocalizationBucketUrl = process.env.REACT_APP_AWS_TRANSLATE;

const detection = {
  lookupLocalStorage: 'language',
};
const fallbackLng = 'en';
const lng = getQueryParam('language') || undefined;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng,
    load: 'languageOnly',
    fallbackLng,
    debug: false,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: function (lng: string) {
        const fileName = `${lng.length > 0 ? lng[0] : fallbackLng}.json`;
        return `${awsLocalizationBucketUrl}${fileName}?t=${new Date().getTime()}`;
      },
      crossDomain: true,
    },
    detection,
    react: {
      wait: true,
      bindI18nStore: false,
      useSuspense: true,
      bindI18n: 'languageChanged',
    },
  });

const intlInstanceNumberFormat = (
  lng: string,
  number: number,
  options: IntlPolyfill.NumberFormatOptions,
) =>
  new IntlPolyfill.NumberFormat(lng, options)
    .formatToParts(number)
    .map(({ type, value }) => {
      if (type === 'currency') {
        return `<span className="currency">${value}</span>`;
      } else {
        return value;
      }
    })
    .reduce((string, part) => string + part);

export let formatterNumber = (number: number, options: IntlPolyfill.NumberFormatOptions) =>
  intlInstanceNumberFormat('en', number, options);

i18n.on('languageChanged', function (lng) {
  const intlLng = lng.replace('_', '-');

  formatterNumber = (number: number, options: IntlPolyfill.NumberFormatOptions = {}) =>
    intlInstanceNumberFormat(intlLng, number, options);
});

export const getLanguage = () => {
  const lng = i18n.language;
  if (!lng) {
    return lng;
  }
  if (lng.split('-').length === 1) {
    return lng;
  }
  return Languages.reduce((real, l) => {
    const ln1 = l.code.split('-');
    const ln2 = lng.split('-');
    if (ln1[0] === ln2[0]) {
      if (ln2[0] === 'zh' && ln2[1] !== undefined && ln2[1] === 'TW') {
        return `${ln2[0]}_${ln2[1]}`;
      }
      return ln1[0];
    }
    return real;
  }, fallbackLng);
};

export const changeLanguage = (lang: string) => {
  i18n.changeLanguage(lang);
};

export const translateWithPrefix = (
  term: string,
  prefix = 'label',
  params: Record<string, unknown> = {},
) => {
  const removePossiblyRedundantPrefix = removePrefix(term, prefix);
  const key = `${prefix}${pascalCase(removePossiblyRedundantPrefix)}`;
  const translatedKey = translate(key, params);
  return translatedKey === key ? term : translatedKey;
};

const t = i18n.t.bind(i18n);

export const translate = (key: string, params: Record<string, unknown> = {}) => {
  return ourEscapeMethod(t(key, params));
};

export const translateCustomParams = (key: string, params: any = {}, wrapperTag: any = {}) => {
  let text = ourEscapeMethod(t(key));
  for (const [key, value] of Object.entries(params)) {
    let param = i18n.t(`${value}`) || `${value}`;
    if (wrapperTag[key]) {
      param = `<${wrapperTag[key]}>${param}</${wrapperTag[key]}>`;
    }
    text = text.replace(key, param);
  }
  return text;
};

const ourEscapeMethod = (s: string) => {
  //TODO: This is a small workaround for the current situation
  // We need to take a better look on it later
  if (!s) {
    return '';
  }
  return s.replace('\\', '');
};

export default i18n;
